var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpiryDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_202_213)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.2 6.3H2.8V7.7H4.2V6.3V6.3ZM7 6.3H5.6V7.7H7V6.3V6.3ZM9.8 6.3H8.4V7.7H9.8V6.3V6.3ZM11.2 1.4H10.5V0H9.1V1.4H3.5V0H2.1V1.4H1.4C0.63 1.4 0 2.03 0 2.79V12.6C0 13.37 0.62 14 1.39 14H11.2C11.97 14 12.6 13.37 12.6 12.6V2.8C12.6 2.03 11.97 1.4 11.2 1.4V1.4ZM11.2 12.6H1.4V4.9H11.2V12.6V12.6Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_202_213"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpiryDate);
export default __webpack_public_path__ + "static/media/ExpiryDate.e3e4d195efcda39dc9daca664a506205.svg";
export { ForwardRef as ReactComponent };